export const statusStyles = {
  server: {
    unreachable: {
      backgroundColor: ({ palette }: any) => palette.gray[50],
      color: ({ palette }: any) => palette.dominant[300],
      borderColor: ({ palette }: any) => palette.dark[40],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    online: {
      backgroundColor: ({ palette }: any) => palette.others.bg,
      color: ({ palette }: any) => palette.satisfaction[90],
      borderColor: ({ palette }: any) => palette.satisfaction[90],
      borderWidth: "1px",
      borderStyle: "solid",
    },
    offline: {
      color: ({ palette }: any) => palette.gray[50],
      backgroundColor: ({ palette }: any) => palette.satisfaction[80],
    },
    Error: {
      color: ({ palette }: any) => palette.others.deadline,
      backgroundColor: ({ palette }: any) => palette.others.deadlineBg,
    },
  },
  broadcastingSpeed: {
    normal: {
      backgroundColor: ({ palette }: any) => palette.gray[50],
      color: ({ palette }: any) => palette.dominant[300],
      borderColor: ({ palette }: any) => palette.dark[40],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    fast: {
      color: ({ palette }: any) => palette.others.deadline,
      backgroundColor: ({ palette }: any) => palette.others.deadlineBg,
    },
  },

  broadcastingNumber: {
    created: {
      color: "#808080",
      backgroundColor: "#eee",
    },
    retry: {
      backgroundColor: ({ palette }: any) => palette.gray[50],
      color: ({ palette }: any) => palette.satisfaction[85],
      borderColor: ({ palette }: any) => palette.satisfaction[85],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    blocked: {
      backgroundColor: ({ palette }: any) => palette.gray[50],
      color: ({ palette }: any) => palette.dominant[500],
      borderColor: ({ palette }: any) => palette.dark[40],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    pending: {
      backgroundColor: ({ palette }: any) => palette.gray[50],
      color: ({ palette }: any) => palette.dominant[500],
      borderColor: ({ palette }: any) => palette.dark[40],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    failed: {
      color: ({ palette }: any) => palette.others.deadlineBg,
      backgroundColor: ({ palette }: any) => palette.others.deadline,
    },
    sending: {
      backgroundColor: ({ palette }: any) => palette.gray[50],
      color: ({ palette }: any) => palette.dominant[300],
      borderColor: ({ palette }: any) => palette.dark[40],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    SENT: {
      color: ({ palette }: any) => palette.others.bg,
      backgroundColor: ({ palette }: any) => palette.satisfaction[90],
    },
    device_off: {
      backgroundColor: ({ palette }: any) => palette.gray[50],
      color: ({ palette }: any) => palette.dominant[300],
      borderColor: ({ palette }: any) => palette.dark[40],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    invalid_number: {
      backgroundColor: ({ palette }: any) => palette.gray[50],
      color: ({ palette }: any) => palette.dominant[300],
      borderColor: ({ palette }: any) => palette.dark[40],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    no_answer: {
      backgroundColor: (thm: any) => thm.palette.others.deadlineBg,
      color: (thm: any) => thm.palette.others.deadline,
      borderColor: "#FF7F7F",
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    rejected: {
      backgroundColor: ({ palette }: any) => palette.gray[50],
      color: ({ palette }: any) => palette.dominant[300],
      borderColor: ({ palette }: any) => palette.dark[40],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    busy: {
      backgroundColor: ({ palette }: any) => palette.gray[50],
      color: ({ palette }: any) => palette.dominant[300],
      borderColor: ({ palette }: any) => palette.dark[40],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    unreachable: {
      backgroundColor: ({ palette }: any) => palette.gray[50],
      color: ({ palette }: any) => palette.dominant[300],
      borderColor: ({ palette }: any) => palette.dark[40],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    canceled: {
      backgroundColor: ({ palette }: any) => palette.others.deadline,
      color: ({ palette }: any) => palette.others.deadlineBg,
      borderColor: ({ palette }: any) => palette.others.deadline,
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    waiting_for_send: {
      bgcolor: "#FFA500",
      color: "#fff",
    },
    answered: {
      color: ({ palette }: any) => palette.others.bg,
      backgroundColor: ({ palette }: any) => palette.satisfaction[90],
    },
  },
  broadcastingStatus: {
    pending: {
      color: ({ palette }: any) => palette.gray[50],
      backgroundColor: ({ palette }: any) => palette.satisfaction[80],
    },
    paying: {
      backgroundColor: ({ palette }: any) => palette.others.bg,
      color: ({ palette }: any) => palette.satisfaction[90],
      borderColor: ({ palette }: any) => palette.satisfaction[90],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    paid: {
      backgroundColor: ({ palette }: any) => palette.others.bg,
      color: ({ palette }: any) => palette.satisfaction[90],
      borderColor: ({ palette }: any) => palette.satisfaction[90],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    not_paid: {
      backgroundColor: ({ palette }: any) => palette.satisfaction[80],
      color: ({ palette }: any) => palette.others.bg,
    },
    failed: {
      backgroundColor: ({ palette }: any) => palette.others.bg,
      color: ({ palette }: any) => palette.error[100],
      borderColor: ({ palette }: any) => palette.error[100],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    sending: {
      backgroundColor: ({ palette }: any) => palette.gray[50],
      color: ({ palette }: any) => palette.satisfaction[90],
      borderColor: ({ palette }: any) => palette.satisfaction[90],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    SENT: {
      color: ({ palette }: any) => palette.others.bg,
      backgroundColor: ({ palette }: any) => palette.satisfaction[90],
    },
    done: {
      backgroundColor: ({ palette }: any) => palette.gray[50],
      color: ({ palette }: any) => palette.dominant[300],
      borderColor: ({ palette }: any) => palette.dark[40],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    expired: {
      backgroundColor: ({ palette }: any) => palette.warning[50],
      color: ({ palette }: any) => palette.warning[120],
      borderColor: ({ palette }: any) => palette.warning[120],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    canceled: {
      color: ({ palette }: any) => palette.others.bg,
      backgroundColor: ({ palette }: any) => palette.others.deadline,
    },
  },
  file: {
    verified: {
      color: ({ palette }: any) => palette.others.bg,
      backgroundColor: ({ palette }: any) => palette.satisfaction[90],
    },
    rejected: {
      color: ({ palette }: any) => palette.others.deadline,
      backgroundColor: ({ palette }: any) => palette.others.deadlineBg,
    },
    pending: {
      color: ({ palette }: any) => palette.others.pending,
      backgroundColor: ({ palette }: any) => palette.others.pendingBg,
    },
    canceled: {
      color: ({ palette }: any) => palette.dominant[300],
      backgroundColor: ({ palette }: any) => palette.gray[100],
    },
  },
  ticket: {
    closed: {
      backgroundColor: ({ palette }: any) => palette.gray[50],
      color: ({ palette }: any) => palette.dominant[300],
      borderColor: ({ palette }: any) => palette.dark[40],
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "99px",
    },
    pending: {
      color: ({ palette }: any) => palette.gray[50],
      backgroundColor: ({ palette }: any) => palette.satisfaction[80],
    },
    in_progress: {
      color: ({ palette }: any) => palette.gray[50],
      backgroundColor: ({ palette }: any) => palette.satisfaction[80],
    },

    answered: {
      color: ({ palette }: any) => palette.others.bg,
      backgroundColor: ({ palette }: any) => palette.satisfaction[90],
    },
  },
  token: {
    removed: {
      color: ({ palette }: any) => palette.dominant[300],
      backgroundColor: ({ palette }: any) => palette.gray[100],
    },
    online: {
      backgroundColor: ({ palette }: any) => palette.others.bg,
      color: ({ palette }: any) => palette.satisfaction[90],
      borderColor: ({ palette }: any) => palette.satisfaction[90],
      borderWidth: "1px",
      borderStyle: "solid",
    },
  },

  partner: {
    active: {
      color: ({ palette }: any) => palette.others.bg,
      backgroundColor: ({ palette }: any) => palette.satisfaction[90],
    },
    inactive: {
      color: ({ palette }: any) => palette.others.deadline,
      backgroundColor: ({ palette }: any) => palette.others.deadlineBg,
    },
  },
  statusCodes:{
    200:{
      color: () => "#fff",
      backgroundColor: () => "#3c9a4f",
    } ,
    201:{
      color: () => "#fff",
      backgroundColor: () => "#3c9a4f",
    } ,
    500:{
      color: () => "#fff",
      backgroundColor: () => "#fc4d55",
    } ,
    422:{
      color: () => "#fff",
      backgroundColor: () => "#ffc107",
    } ,
    401:{
      color: () => "#fff",
      backgroundColor: () => "#800080",
    } ,
    403:{
      color: () => "#fff",
      backgroundColor: () => "#800080",
    } ,
    404:{
      color: () => "#fff",
      backgroundColor: () => "#80878c",
    } ,
  },
  payment: {
    complete: {
      color: ({ palette }: any) => palette.others.bg,
      backgroundColor: ({ palette }: any) => palette.satisfaction[90],
    },
    paying: {
      color: ({ palette }: any) => palette.others.bg,
      backgroundColor: ({ palette }: any) => palette.satisfaction[90],
    },
    failed: {
      color: ({ palette }: any) => palette.others.deadline,
      backgroundColor: ({ palette }: any) => palette.others.deadlineBg,
    },
    paid: {
      backgroundColor: ({ palette }: any) => palette.others.bg,
      color: ({ palette }: any) => palette.satisfaction[90],
      borderColor: ({ palette }: any) => palette.satisfaction[90],
      borderWidth: "1px",
      borderStyle: "solid",
    },
    pending: {
      color: ({ palette }: any) => palette.gray[50],
      backgroundColor: ({ palette }: any) => palette.satisfaction[80],
    },
  },
};

export const statusInfo = {
  fa: {
    server: {
      online: "آنلاین",
      offline: "آفلاین",
      Error: "خطا",
      unreachable: "خارج از دسترس",
    },
    payment: {
      paying: "در حال پرداخت",
      failed: "ناموفق",
      paid: "موفق",
      complete: "اتمام",
      pending: "پرداخت در حال بررسی",
    },
    broadcastingNumber: {
      created: "ایجاد شده",
      waiting_for_send: "در انتظار ارسال",
      sending: "در حال ارسال",
      failed: "ناموفق",
      answered: "پاسخ داده شده",
      blocked: "مسدود شده",
      no_answer: "بی پاسخ",
      busy: "مشغول",
      rejected: "رد داده شده",
      unreachable: "خارج از دسترس",
      device_off: "خاموش",
      invalid_number: "شماره نامعتبر",
      canceled: "کنسل شده",
      SENT: "ارسال شده",
      retry: "تلاش دوباره",
      pending: "در انتظار ارسال",
    },
    broadcastingStatus: {
      pending: "در انتظار پرداخت",
      paying: "در حال پرداخت",
      paid: "پرداخت شده",
      not_paid: "پرداخت نشده",
      failed: "ناموفق",
      sending: "در حال ارسال",
      SENT: "ارسال شده",
      done: "ارسال شده",
      expired: "منقضی شده",
      canceled: "کنسل شده",
    },
    broadcastingSpeed: {
      normal: "عادی",
      fast: "سریع",
    },
    statusCodes:{
        200:'200' ,
        201:'201',
        500:'500' ,
        422:'422',
        401:'401' ,
        403:'403',
        404:'404',
      },
    file: {
      pending: "در انتظار بررسی",
      verified: "تایید شده",
      rejected: "رده شده",
      canceled: "کنسل شده",
    },
    ticket: {
      closed: "بسته شده",
      answered: "پاسخ داده شده",
      pending: "در انتظار بررسی",
      in_progress: "در حال پیگیری",
    },
    token: {
      online: "آنلاین",
      removed: "حدف شده",
    },
    partner: {
      active: "فعال",
      inactive: "غیرفعال",
    },
  },
  en: {
    server: {
      online: "آنلاین",
      offline: "آفلاین",
      Error: "خطا",
      unreachable: "خارج از دسترس",
    },
    statusCodes:{
        200:'200' ,
        201:'201',
        500:'500' ,
        422:'422',
        401:'401' ,
        403:'403',
        404:'404',
      },
    payment: {
      paying: "در حال پرداخت",
      failed: "ناموفق",
      paid: "موفق",
      complete: "اتمام",
      pending: "پرداخت در حال بررسی",
    },
    broadcastingNumber: {
      created: "ایجاد شده",
      waiting_for_send: "در انتظار ارسال",
      sending: "در حال ارسال",
      failed: "ناموفق",
      answered: "پاسخ داده شده",
      blocked: "مسدود شده",
      no_answer: "بی پاسخ",
      busy: "مشغول",
      rejected: "رد داده شده",
      unreachable: "خارج از دسترس",
      device_off: "خاموش",
      invalid_number: "شماره نامعتبر",
      SENT: "ارسال شده",
      canceled: "کنسل شده",
    },
    broadcastingStatus: {
      pending: "در انتظار پرداخت",
      paying: "در حال پرداخت",
      paid: "پرداخت شده",
      sending: "در حال ارسال",
      SENT: "ارسال شده",
    },
    file: {
      pending: "در انتظار بررسی",
      verified: "تایید شده",
      rejected: "رده شده",
      canceled: "کنسل شده",
    },
    partner: {
      active: "فعال",
      inactive: "غیرفعال",
    },
    ticket: {
      closed: "بسته شده",
      answered: "پاسخ داده شده",
      pending: "در انتظار پاسخ",
    },
    token: {
      online: "آنلاین",
      removed: "حدف شده",
    },
  },
};
